import type { TupleToUnion } from 'type-fest'

export const Actions = [
  'accept',
  'administer',
  'archive',
  'comment',
  'complete',
  'create',
  'delete',
  'duplicate',
  'edit',
  'remove',
  'submit',
  'update',
  'upload',
  'view',
  'viewAll',
] as const

export type Action = TupleToUnion<typeof Actions>
